import { Card, Form, Input, Flex } from "antd";
import React from "react";
import { useSelector } from "react-redux";

const GeneralCard = () => {
  const themeDefault = useSelector((state) => state.themeDefault);

  return (
    <Card
      bordered
      title="General"
      style={{
        height: 338,
      }}>
      <Flex
        gap={8}
        vertical
        style={{
          borderTop: themeDefault?.info?.newConfig?.cardborder,
          paddingTop: 16,
          marginTop: -16,
        }}>
        <Form.Item
          name="empId"
          label="User ID"
          style={{ width: "100%", marginBottom: 8 }}>
          <Input placeholder="Enter User Id" />
        </Form.Item>

        <Flex gap={16} wrap="wrap">
          <Form.Item
            name="firstName"
            label="First Name"
            rules={[{ required: true, message: "First Name is required" }]}
            style={{ flex: 1, minWidth: 220, marginBottom: 8 }}>
            <Input placeholder="Enter First Name" />
          </Form.Item>

          <Form.Item
            name="lastName"
            label="Last Name"
            rules={[{ required: true, message: "Last Name is required" }]}
            style={{ flex: 1, minWidth: 220, marginBottom: 8 }}>
            <Input placeholder="Enter Last Name" />
          </Form.Item>
        </Flex>

        <Form.Item
          name="displayName"
          label="Display Name"
          style={{ width: "100%", marginBottom: 0 }}>
          <Input placeholder="Enter Display Name" />
        </Form.Item>
      </Flex>
    </Card>
  );
};

export default GeneralCard;
